const ATTEMPT_LOGIN = "ATTEMPT_LOGIN";
const AUTHENTICATION_SUCCEEDED = "AUTHENTICATION_SUCCEEDED";
const AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED";

export default {
  ATTEMPT_LOGIN,
  AUTHENTICATION_SUCCEEDED,
  AUTHENTICATION_FAILED
};
